import { createContext, useContext, useState, useEffect, useCallback } from 'react'
import { portalAuthApi, portalMeApi } from '../services/portalApi'

const PortalAuthContext = createContext(null)

export function PortalAuthProvider({ children }) {
  const [tenant, setTenant] = useState(() => {
    try { return JSON.parse(localStorage.getItem('tenant_user')) } catch { return null }
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem('tenant_token')
    if (!token) { setLoading(false); return }

    portalMeApi.show()
      .then(({ data }) => {
        setTenant(data.data)
        localStorage.setItem('tenant_user', JSON.stringify(data.data))
      })
      .catch(() => {
        localStorage.removeItem('tenant_token')
        localStorage.removeItem('tenant_user')
        setTenant(null)
      })
      .finally(() => setLoading(false))
  }, [])

  const login = useCallback(async (email, password) => {
    const { data } = await portalAuthApi.login({ email, password })
    localStorage.setItem('tenant_token', data.token)
    localStorage.setItem('tenant_user',  JSON.stringify(data.user))
    setTenant(data.user)
    return data.user
  }, [])

  const activate = useCallback(async (token, password) => {
    const { data } = await portalAuthApi.activate(token, {
      password,
      password_confirmation: password,
    })
    localStorage.setItem('tenant_token', data.token)
    localStorage.setItem('tenant_user',  JSON.stringify(data.user))
    setTenant(data.user)
    return data.user
  }, [])

  const logout = useCallback(async () => {
    try { await portalAuthApi.logout() } catch {}
    localStorage.removeItem('tenant_token')
    localStorage.removeItem('tenant_user')
    setTenant(null)
  }, [])

  const refresh = useCallback(async () => {
    const { data } = await portalMeApi.show()
    setTenant(data.data)
    localStorage.setItem('tenant_user', JSON.stringify(data.data))
    return data.data
  }, [])

  return (
    <PortalAuthContext.Provider value={{ tenant, loading, login, activate, logout, refresh }}>
      {children}
    </PortalAuthContext.Provider>
  )
}

export const usePortalAuth = () => {
  const ctx = useContext(PortalAuthContext)
  if (!ctx) throw new Error('usePortalAuth must be used within PortalAuthProvider')
  return ctx
}
